import { supabase } from './supabase';
import type { BreathingPreset } from './api';

export type NewBreathingPreset = Omit<
  BreathingPreset,
  'id' | 'created_at' | 'updated_at'
>;

const TABLE = 'breathing_presets';

export async function listBreathingPresets(
  includeInactive = true
): Promise<BreathingPreset[]> {
  let query = supabase
    .from(TABLE)
    .select('*')
    .order('name', { ascending: true });

  if (!includeInactive) {
    query = query.eq('is_active', true);
  }

  const { data, error } = await query;
  if (error) throw error;
  return (data as BreathingPreset[]) || [];
}

export async function createBreathingPreset(
  input: NewBreathingPreset
): Promise<BreathingPreset> {
  const payload = {
    name: input.name,
    slug: input.slug,
    inhale: input.inhale,
    hold_full: input.hold_full,
    exhale: input.exhale,
    hold_empty: input.hold_empty,
    default_duration: input.default_duration,
    default_background: input.default_background ?? null,
    default_audio: input.default_audio,
    auto_start: input.auto_start,
    is_active: input.is_active,
    is_public: input.is_public,
  };

  const { data, error } = await supabase
    .from(TABLE)
    .insert(payload)
    .select('*')
    .single();

  if (error) throw error;
  return data as BreathingPreset;
}

export async function updateBreathingPreset(
  id: string,
  input: NewBreathingPreset
): Promise<BreathingPreset> {
  const payload = {
    name: input.name,
    slug: input.slug,
    inhale: input.inhale,
    hold_full: input.hold_full,
    exhale: input.exhale,
    hold_empty: input.hold_empty,
    default_duration: input.default_duration,
    default_background: input.default_background ?? null,
    default_audio: input.default_audio,
    auto_start: input.auto_start,
    is_active: input.is_active,
    is_public: input.is_public,
  };

  const { data, error } = await supabase
    .from(TABLE)
    .update(payload)
    .eq('id', id)
    .select('*')
    .single();

  if (error) throw error;
  return data as BreathingPreset;
}

export async function deleteBreathingPreset(id: string): Promise<void> {
  const { error } = await supabase.from(TABLE).delete().eq('id', id);
  if (error) throw error;
}
